const resolveProjectUrl = (project, artist, fallback) => artist && artist.slug ? (
	`/project/${artist.slug}/${project.slug}-${project.id}`
) : project && project.id && project.slug ? (
	`/project/${project.slug}-${project.id}`
) : fallback;

export default resolveProjectUrl